import { extractData, getShowroomAll } from "api"
import { trackPopUpOpen } from "common/analytics"
import NextLink from "common/bit/NextLink"
import { isModelHasTestDriveIframe } from "components/Schedule/getIframeLink"
import PurchaseToolsRow from "components/carModelPage/popups/purchaseTools/PurchaseToolsRow"
import TestDrivePopup from "components/carModelPage/popups/testDrive/TestDrivePopup"
import { useEffect, useState } from "react"
import Finance from "reusable/finance"
import { useTypedSelector } from "store"
import styled from "styled-components"
import { STEPS_EN } from "../wizard/constants"

const StyledWrapper = styled.div`
  text-align: center;
  overflow: auto;
  width: 100%;
`

type PurchaseToolsProps = {
  className?: string
}

const PurchaseTools = ({ className }: PurchaseToolsProps) => {
  const [popupOpen, setPopupOpen] = useState<boolean>(false)
  const [leadFormPopupOpen, setLeadFormPopupOpen] = useState(false)
  const [showRoomList, setShowRoomList] = useState([])

  const { auth, wizard } = useTypedSelector((state) => state)

  useEffect(() => {
    const fetchData = async () => {
      const data = await getShowroomAll(null, null).then(extractData)
      setShowRoomList(data?.body)
    }
    fetchData().catch((error) => console.log(error))
  }, [])

  const { userInfo } = auth

  if (!wizard?.model?.id) return

  const {
    model: { id: modelId },
  } = wizard

  return (
    <>
      <StyledWrapper className={className || ""}>
        {/* link: "/showRooms"*/}
        {isModelHasTestDriveIframe(wizard.model.id) ? (
          <NextLink
            href={`/test-drive/${wizard?.model?.id || "1000"}`}
            passHref
          >
            <PurchaseToolsRow
              text="להזמנת נסיעת הדגמה"
              iconName="fi_calendar"
              page={STEPS_EN.summary}
              onClick={() => {
                trackPopUpOpen("showrooms meeting")
              }}
            />
          </NextLink>
        ) : (
          <PurchaseToolsRow
            text="להזמנת נסיעת הדגמה"
            iconName="fi_calendar"
            page={STEPS_EN.summary}
            onClick={() => {
              setLeadFormPopupOpen(true)
              trackPopUpOpen("showrooms meeting")
            }}
          />
        )}

        <PurchaseToolsRow
          text="לקבל הצעת מימון"
          iconName="calculator"
          page={STEPS_EN.summary}
          onClick={() => {
            // onClose()
            setPopupOpen(true)
          }}
        />
        <a
          href="https://api.whatsapp.com/send/?phone=972532397240&text&type=phone_number&app_absent=0"
          target="_blank"
          rel="noreferrer"
        >
          <PurchaseToolsRow
            text="לצ'אט עם נציג"
            iconName="fi_message-circle"
            page={STEPS_EN.summary}
          />
        </a>
        <TestDrivePopup
          open={leadFormPopupOpen}
          onClose={() => {
            setLeadFormPopupOpen(false)
          }}
          formType="test-drive"
          showRoomsList={showRoomList}
          dialogClass="summaryTestDrive"
          title="תיאום נסיעת מבחן"
          modelId={modelId}
          userInfo={userInfo}
          buttonText="תאמו איתי נסיעת מבחן"
          analyticName="showrooms meeting"
          isShop
        />
      </StyledWrapper>
      <Finance
        onlyClick={true}
        modelId={wizard?.model?.id}
        modelName={wizard?.model?.name}
        popupOpen={popupOpen}
        setPopupOpen={setPopupOpen}
      />
    </>
  )
}
export default PurchaseTools
